import withLazyLoad from './with_lazy_load';

export default withLazyLoad;
